import{useBackdropSpinnerContext as t}from"../context/BackdropSpinnerContext.mjs";function e(){const{isShowSpinner:e}=t();return{executeRequest:async t=>{e(!0),await t(),e(!1)}}}export{e as useBackdropSpinner};
